import PropTypes from 'prop-types'
import React from "react"
import { Modal, ModalBody } from "reactstrap"

const ConfirmModal = ({ show, onYesClick, onNoClick, val }) => {
  return (
    <Modal size="md" isOpen={show} toggle={onNoClick} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi mdi-trash-can-outline"></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">Are you sure you want to change ?</p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button type="button" className="btn btn-danger" onClick={onYesClick}>Yes</button>
            <button type="button" className="btn btn-secondary" onClick={onNoClick}>No</button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  onNoClick: PropTypes.func,
  onYesClick: PropTypes.func,
  show: PropTypes.any,
  val: PropTypes.any
}

export default ConfirmModal;
